import { Component, Inject } from '@angular/core';
import {
	MatDialogRef,
	MAT_DIALOG_DATA,
	MatDialogContent,
	MatDialogActions,
} from '@angular/material/dialog';
import { ApiLoadingKeys, ApiService } from 'src/app/services/api.services';
import { LoadingIndicatorService } from 'src/app/services/loading-indicator.service';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatDivider } from '@angular/material/list';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';

export interface DisableAlarmIntegrationDialogComponentData {
	companyId: string;
}

@Component({
	selector: 'app-disable-alarm-integration-dialog',
	templateUrl: './disable-alarm-integration-dialog.component.html',
	styleUrls: [
		'./disable-alarm-integration-dialog.component.scss',
		'../../../../../ui/common/main.scss',
	],
	imports: [
		MatProgressSpinner,
		MatDivider,
		CdkScrollable,
		MatDialogContent,
		MatFormField,
		MatInput,
		FormsModule,
		MatDialogActions,
	],
})
export class DisableAlarmIntegrationDialogComponent {
	errorSavingChanges?: boolean;
	isLoading: boolean = false;
	disableAlarmText =
		$localize`:@@disableAlarmIntegrationDialog-disable:disable` +
		'-' +
		$localize`:@@disableAlarmIntegrationDialog-alarm:alarm`;
	userDisableAlarmTextInput = '';
	companyId!: string;
	disableAjaxForCompanyLoadingKey = ApiLoadingKeys.disableAjaxForCompany;

	constructor(
		private dialogRef: MatDialogRef<DisableAlarmIntegrationDialogComponent>,
		public readonly loadingService: LoadingIndicatorService,
		private readonly apiService: ApiService,
		@Inject(MAT_DIALOG_DATA)
		public data: DisableAlarmIntegrationDialogComponentData
	) {
		this.companyId = this.data.companyId;
	}

	async onConfirmClicked() {
		if (this.loadingService.isLoading(this.disableAjaxForCompanyLoadingKey)) {
			return;
		}
		await this.apiService
			.disableAjaxForCompany(this.companyId)
			.then((res: any) => {
				this.dialogRef.close(true);
			})
			.catch((err: any) => {
				console.error(err);
				this.errorSavingChanges = true;
			});
	}

	onCloseClicked(): void {
		this.dialogRef.close(false);
	}
}
